import Component from "@tunnel-components/@pages/administration/users/component";
import * as React from "react";
import { connect } from "react-redux";
import * as Lodash from "lodash";
import * as EmailValidator from "email-validator";
import * as Utils from "@Cyclope-Utils/index";
import {
  usersloadedactioncreator,
  usersremovedactioncreator,
  usersupdatedactioncreator,
  userscreatedactioncreator,
  UserRightLoadActionCreator,
} from "@tunnel-store/index";
/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onOpenAction
 * @name
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * @property { boolean }      state.UpdateUserserver
     * ......
     */
    this.state = {
      addUsers: false,
      addUsersError: false,
      currentPageNumbers: 1, // nouvelle pagination
      emailError: false,
      firstnameError: false,
      isLogin: [],
      isMail: [],
      isRoles: [],
      // itemsPerPage:6,
      loginError: false,
      nameError: false,
      updateUser: false,
      usersArray: [],
      usersData: [],
      usersHasBeenFound: {},
      remouveuser: false,
      roleError: false,
      someInputError: false,
      // totalElements:1,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onOpenAddUser = this.onOpenAddUser.bind(this);
    this.onOpenAction = this.onOpenAction.bind(this);
    this.onUpdateUser = this.onUpdateUser.bind(this);
    this.onRemouveUser = this.onRemouveUser.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.onRemouve = this.onRemouve.bind(this);
    this.onSubmitUpdateUser = this.onSubmitUpdateUser.bind(this);
    this.onChangeUpdateUser = this.onChangeUpdateUser.bind(this);
    this.removeUserObject = this.removeUserObject.bind(this);
    this.onChangeRoleUser = this.onChangeRoleUser.bind(this);
    this.onSubmitUser = this.onSubmitUser.bind(this);
    this.onChangeRoleUserAdd = this.onChangeRoleUserAdd.bind(this);
    this.onIsMail = this.onIsMail.bind(this);
    this.onIsLogin = this.onIsLogin.bind(this);
    this.onIsRoles = this.onIsRoles.bind(this);
    // nouvelle pagination
    this.onUpdateCurrentPageNumber = this.onUpdateCurrentPageNumber.bind(this);
  }
  // ================================  Nouvelle pagination =============================================
  /**
   * @method onUpdateCurrentPageNumber
   * @description: MAJ de la page courante
   * @param { any } target
   * @infos "https://reactjs.org"
   */
  public onUpdateCurrentPageNumber = (target: any) =>
    this.setState((state: any) => ({
      errorvideo: false,
      currentPageNumbers: Number(target),
    }));

  /**
   * @method
   * @name onSubmitUser
   * @param { any } event
   * @infos "https://reactjs.org"
   */

  public onSubmitUser = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    this.setState((state: any): any => ({ loading: true }));

    if (!Utils.validatorString(this.state.nameUserAdd)) {
      this.setState((state: any): any => ({ nameError: true }));
    }
    if (!Utils.validatorString(this.state.firstNameUserAdd)) {
      this.setState((state: any): any => ({ firstnameError: true }));
    }
    if (!Utils.validatorString(this.state.loginUserAdd)) {
      this.setState((state: any): any => ({ loginError: true }));
    }

    if (
      Lodash.isUndefined(this.state.nameUserAdd) ||
      Lodash.isEqual(this.state.nameUserAdd, "")
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ nameError: true }));
    }
    if (
      Lodash.isUndefined(this.state.firstNameUserAdd) ||
      Lodash.isEqual(this.state.firstNameUserAdd, "")
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ firstnameError: true }));
    }
    if (
      Lodash.isUndefined(this.state.roleUserAdd) ||
      Lodash.isEqual(this.state.roleUserAdd, "")
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ roleError: true }));
    }
    if (
      Lodash.isUndefined(this.state.loginUserAdd) ||
      Lodash.isEqual(this.state.loginUserAdd, "")
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ loginError: true }));
    }

    if (
      !Lodash.isUndefined(this.state.nameUserAdd) &&
      !Lodash.isUndefined(this.state.firstNameUserAdd) &&
      !Lodash.isUndefined(this.state.roleUserAdd) &&
      !Lodash.isUndefined(this.state.loginUserAdd) &&
      !Lodash.isUndefined(this.state.emailUserAdd)
    ) {
      if (
        !Lodash.isEmpty(this.state.nameUserAdd) &&
        !Lodash.isEmpty(this.state.firstNameUserAdd) &&
        !Lodash.isEmpty(this.state.roleUserAdd) &&
        !Lodash.isEmpty(this.state.loginUserAdd) &&
        !Lodash.isEmpty(this.state.emailUserAdd)
      ) {
        if (EmailValidator.validate(this.state.emailUserAdd)) {
          if (
            Utils.validatorString(this.state.nameUserAdd) &&
            Utils.validatorString(this.state.loginUserAdd) &&
            Utils.validatorString(this.state.firstNameUserAdd)
          ) {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({ loading: true }));
            {
              /** dispatch action */
            }
            this.props
              .userscreatedactioncreator(this.state)
              .then(() =>
                this.setState((state: any): any => ({ loading: false }))
              );
          } else {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({
              someInputError: true,
              loading: false,
            }));
          }
        } else {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            emailError: true,
            loading: false,
          }));
        }
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          someInputError: true,
          loading: false,
        }));
      }
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        someInputError: true,
        loading: false,
      }));
    }

    if (!EmailValidator.validate(this.state.emailUserAdd)) {
      this.setState((state: any): any => ({ emailError: true }));
    }
  };
  /**
   * @method
   * @name onChangeRoleUserAdd
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onChangeRoleUserAdd = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @description :
     * @name  options
     * @types any
     */
    const options = event.target.options;
    /**
     * @constant
     * @description :
     * @name  roleUserAdd
     * @types any[]
     */
    const roleUserAdd: any[] = [];
    {
      /** boucle  */
    }
    for (let i = 0; i < Math.ceil(options.length); i++) {
      if (options[i].selected) {
        roleUserAdd.push(options[i].value);
      }
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      roleUserAdd,
      addUsersError: false,
      someInputError: false,
      firstnameError: false,
      nameError: false,
      emailError: false,
      roleError: false,
      loginError: false,
      someInputUpdateError: false,
      emailUpdateError: false,
      errorUpdateUser: false,
    }));
  };
  /**
   * @method
   * @name removeUserObject
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public removeUserObject = (event: any): void => {
    /**
     * @constant
     * @description :
     * @name  user
     * @types any
     */
    const user: any = this.state.usersHasBeenFound;
    {
      /**  */
    }
    if (!Lodash.isEmpty(user)) {
      {
        /** Empêcher la mutation du state */
      }

      this.setState((state: any): any => ({
        UpdateUserserver: false,
        loading: true,
        remouveuser: !this.state.remouveuser,
      }));
      {
        /** dispatch action */
      }
      this.props
        .usersremovedactioncreator(String(user.login))
        .then(() => this.props.usersloadedactioncreator())
        .then(() => this.setState((state: any): any => ({ loading: false })))
        .then(() => this.setState((state: any): any => ({ addUsers: false })));
    }
  };
  /**
   * @method
   * @name onSubmitUpdateUser
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSubmitUpdateUser = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ loading: true }));

    // Déclaration des variables
    let userUpdateName; // MAJ du nom de l'utilisateur
    let userUpdateFirstName; // Maj du prénom de l'utilisateur
    let userUpdateEmail; // MAj de l'émail de l'utilisateur
    let userUpdateRole; // MAj du rôle de l'utilisateur

    // vérification des variables
    if (!Lodash.isUndefined(this.state.usersHasBeenFound)) {
      if (
        Lodash.isUndefined(this.state.nameuser) ||
        Lodash.isEmpty(this.state.nameuser)
      ) {
        userUpdateName = this.state.usersHasBeenFound.lastName;
      } else {
        userUpdateName = this.state.nameuser;
        if (!Utils.validatorString(this.state.nameuser)) {
          this.setState((state: any): any => ({ nameError: true }));
        }
      }

      if (
        Lodash.isUndefined(this.state.firstnameUser) ||
        Lodash.isEmpty(this.state.firstnameUser)
      ) {
        userUpdateFirstName = this.state.usersHasBeenFound.firstName;
      } else {
        userUpdateFirstName = this.state.firstnameUser;
        if (!Utils.validatorString(this.state.firstnameUser)) {
          this.setState((state: any): any => ({ firstnameError: true }));
        }
      }

      if (
        Lodash.isUndefined(this.state.emailuser) ||
        Lodash.isEmpty(this.state.emailuser)
      ) {
        userUpdateEmail = this.state.usersHasBeenFound.email;
      } else {
        userUpdateEmail = this.state.emailuser;
      }
      if (
        Lodash.isUndefined(this.state.roleuser) ||
        Lodash.isEmpty(this.state.roleuser)
      ) {
        userUpdateRole = this.state.usersHasBeenFound.authorities;
      } else {
        userUpdateRole = this.state.roleuser;
      }

      if (EmailValidator.validate(userUpdateEmail)) {
        if (
          Utils.validatorString(userUpdateFirstName) &&
          Utils.validatorString(userUpdateName)
        ) {
          // Nouvelles données de l'utilisateur
          const MAJuser: any = {
            id: this.state.usersHasBeenFound.id, // id
            email: userUpdateEmail,
            firstName: userUpdateFirstName,
            lastName: userUpdateName,
            authorities: userUpdateRole,
            login: this.state.usersHasBeenFound.login,
          };
          this.props
            .usersupdatedactioncreator(MAJuser)
            .then(() =>
              this.setState((state: any): any => ({ loading: false }))
            );
        } else {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            loading: false,
            someInputUpdateError: true,
          }));
        }
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          emailUpdateError: true,
          loading: false,
          someInputUpdateError: true,
        }));
      }
    }
  };
  /**
   * @method
   * @name onChangeRoleUser
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onChangeRoleUser = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    /**
     * @constant
     * @description:
     */
    const options = event.target.options;

    const roleuser: any[] = [];

    for (let i = 0; i < Math.ceil(options.length); i++) {
      if (options[i].selected) {
        roleuser.push(options[i].value);
      }
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      roleuser,
      addUsersError: false,
      someInputError: false,
      firstnameError: false,
      nameError: false,
      emailError: false,
      roleError: false,
      loginError: false,
      someInputUpdateError: false,
      emailUpdateError: false,
      errorUpdateUser: false,
    }));
  };
  /**
   * @method
   * @name onChangeUpdateUser
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onChangeUpdateUser = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState({
      [event.target.name]: event.target.value,
    });
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      someInputError: false,
      firstnameError: false,
      nameError: false,
      emailError: false,
      roleError: false,
      loginError: false,
    }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      someInputUpdateError: false,
      emailUpdateError: false,
      errorUpdateUser: false,
    }));
  };
  /**
   * @method
   * @name onUpdateUser
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onUpdateUser = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ updateUser: !this.state.updateUser });
    {
      /** Empêcher la mutation du state */
    }
    this.setState({
      loading: false,
      addUsersError: false,
      someInputError: false,
      firstnameError: false,
      nameError: false,
      emailError: false,
      roleError: false,
      loginError: false,
      someInputUpdateError: false,
      emailUpdateError: false,
      errorUpdateUser: false,
    });
  };

  /**
   * @method
   * @name onRemouveUser
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onRemouveUser = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    // this.setState({  remouveuser: !this.state.remouveuser});
    this.setState((state: any): any => ({ remouveuser: false }));
  };
  /**
   * @method
   * @name onUpdate
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onUpdate = (elem: any) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      updateUser: !this.state.updateUser,
      usersHasBeenFound: elem,
    }));
  };
  /**
   * @method
   * @name onRemouve
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onRemouve = (elem: any) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      usersHasBeenFound: elem,
      remouveuser: !this.state.remouveuser,
    }));
  };
  /**
   * @method
   * @name onOpenAction
   * @param { any } event
   * @param { param } event
   * @infos "https://reactjs.org"
   */
  public onOpenAction = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @description :
     * @name  usersArray
     * @types boolean[]
     */
    const usersArray: boolean[] = [];
    {
      /** boucle  */
    }
    for (let i = 1; i <= Math.ceil(this.state.usersArray.length); i++) {
      usersArray.push(false);
    }

    usersArray[param] = !this.state.usersArray[param];
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ usersArray }));
  };

  /**
   * @method
   * @name onIsMail
   * @param { any } event
   * @param { param } event
   * @infos "https://reactjs.org"
   */
  public onIsMail = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @description :
     * @name  isMail
     * @types boolean[]
     */
    const isMail: boolean[] = [];
    {
      /** boucle  */
    }
    for (let i = 1; i <= Math.ceil(this.state.isMail.length); i++) {
      isMail.push(false);
    }

    isMail[param] = !this.state.isMail[param];
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ isMail }));
  };
  /**
   * @method
   * @name onIsLogin
   * @param { any } event
   * @param { param } event
   * @infos "https://reactjs.org"
   */
  public onIsLogin = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @description :
     * @name  isLogin
     * @types boolean[]
     */
    const isLogin: boolean[] = [];
    {
      /** boucle  */
    }
    for (let i = 1; i <= Math.ceil(this.state.isLogin.length); i++) {
      isLogin.push(false);
    }

    isLogin[param] = !this.state.isLogin[param];
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ isLogin }));
  };
  /**
   * @method
   * @name onIsRoles
   * @param { any } event
   * @param { param } event
   * @infos "https://reactjs.org"
   */
  public onIsRoles = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @description :
     * @name  isRoles
     * @types boolean[]
     */
    const isRoles: boolean[] = [];
    {
      /** boucle  */
    }
    for (let i = 1; i <= Math.ceil(this.state.isRoles.length); i++) {
      isRoles.push(false);
    }

    isRoles[param] = !this.state.isRoles[param];
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ isRoles }));
  };
  /**
   * @method
   * @description: ouverture et fermeture de la popup
   * @name onOpenAddUser
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onOpenAddUser = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ addUsers: !this.state.addUsers }));
    this.setState((state: any): any => ({
      loading: false,
      addUsersError: false,
      someInputError: false,
      firstnameError: false,
      nameError: false,
      roleError: false,
      loginError: false,
      emailError: false,
      someInputUpdateError: false,
      emailUpdateError: false,
      errorUpdateUser: false,
    }));
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ errorserver: false, loading: true }));
    {
      /** dispatch action */
    }
    this.props.UserRightLoadActionCreator();
    this.props
      .usersloadedactioncreator()
      .then(() => this.setState((state: any): any => ({ loading: false })));
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** vérification de l'existence de l'élement  */
    }
    if (prevState.currentPageNumbers !== this.state.currentPageNumbers) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        errorserver: false,
        loading: true,
      }));
      {
        /** dispatch action */
      }
      this.props
        .usersloadedactioncreator()
        .then(() => this.setState((state: any): any => ({ loading: false })));
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** comparaison */
    }
    if (nextProps.errors !== this.props.errors) {
      {
        /** vérification de l'existance */
      }
      if (!Lodash.isUndefined(nextProps.errors)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ errorserver: true }));
      }
    } else if (nextProps.rightdata !== this.props.rightdata) {
      {
        /** Empêcher la mutation du state */
      }
      if (!Lodash.isUndefined(nextProps.rightdata)) {
        this.setState((state: any): any => ({
          rightdata: nextProps.rightdata,
        }));
      }
    } else if (nextProps.data !== this.props.data) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.data)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          itemsPerPage: nextProps.data.length,
          usersData: nextProps.data,
          totalElements: nextProps.data.length,
        }));
        const isLogin: boolean[] = [];
        const isMail: boolean[] = [];
        const isRoles: boolean[] = [];
        /**
         * @constant
         * @description :
         * @name  usersArray
         * @types boolean[]
         */
        const usersArray: boolean[] = [];
        {
          /** boucle  */
        }
        for (let i = 1; i <= Math.ceil(nextProps.data.length); i++) {
          usersArray.push(false);
          isLogin.push(false);
          isMail.push(false);
          isRoles.push(false);
        }
        this.setState((state: any): any => ({
          usersArray,
          isLogin,
          isMail,
          isRoles,
          item: nextProps.data,
        }));
        {
          /** vérification de l'existence de l'élement  */
        }
        if (nextProps.data.length === 0) {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            noIncidents: true,
            errorserver: false,
          }));
        }
      }
    } else if (nextProps.erroruserupdate !== this.props.erroruserupdate) {
      if (!Lodash.isUndefined(nextProps.erroruserupdate)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ errorUpdateUser: true }));
      }
    } else if (nextProps.userupdating !== this.props.userupdating) {
      if (!Lodash.isUndefined(nextProps.userupdating)) {
        this.props
          .usersloadedactioncreator()
          .then(() =>
            this.setState((state: any): any => ({ updateUser: false }))
          );
      }
    } else if (nextProps.useradding !== this.props.useradding) {
      if (!Lodash.isUndefined(nextProps.useradding)) {
        this.props
          .usersloadedactioncreator()
          .then(() =>
            this.setState((state: any): any => ({
              loading: false,
              addUsersError: false,
              someInputError: false,
              emailError: false,
            }))
          )
          .then(() =>
            this.setState((state: any): any => ({ addUsers: false }))
          );
      }
    } else if (nextProps.useraddingerror !== this.props.useraddingerror) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.useraddingerror)) {
        this.setState((state: any): any => ({ addUsersError: true }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        {...this.props}
        {...this.state}
        onOpenAddUser={this.onOpenAddUser}
        onRemouveUser={this.onRemouveUser}
        onUpdateUser={this.onUpdateUser}
        onRemouve={this.onRemouve}
        onUpdate={this.onUpdate}
        onOpenAction={this.onOpenAction}
        onSubmitUpdateUser={this.onSubmitUpdateUser}
        onChangeUpdateUser={this.onChangeUpdateUser}
        removeUserObject={this.removeUserObject}
        onChangeRoleUser={this.onChangeRoleUser}
        onSubmitUser={this.onSubmitUser}
        onChangeRoleUserAdd={this.onChangeRoleUserAdd}
        onIsMail={this.onIsMail}
        onIsRoles={this.onIsRoles}
        onIsLogin={this.onIsLogin}
        // nouvelle pagination
        onUpdateCurrentPageNumber={this.onUpdateCurrentPageNumber}
      />
    );
  }
}

/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    data: state.UsersLoaded.data,
    erroruserupdate: state.UsersUpdated.error,
    errors: state.UsersLoaded.error,
    useradding: state.UsersCreated.data,
    useraddingerror: state.UsersCreated.error,
    userupdating: state.UsersUpdated.data,
    rightdata: state.UserRightLoad.data,
  };
}

{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  userscreatedactioncreator,
  usersloadedactioncreator,
  usersremovedactioncreator,
  usersupdatedactioncreator,
  UserRightLoadActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/administration/users/container.tsx